import CONSUMPTION_TYPE_OPTIONS from "../constants/consumptionTypeOptions";

type ConsumptionType = (typeof CONSUMPTION_TYPE_OPTIONS)[number]["value"];

const getConsumptionTypeLabel = (consumptionType: ConsumptionType) => {
  const option = CONSUMPTION_TYPE_OPTIONS.find((option) => option.value === consumptionType);
  return option ? option.label : consumptionType;
};

export default getConsumptionTypeLabel;
